import { useAuth } from "../../context/AuthContext";
import { Button } from "react-bootstrap";
import "../menu/menu.css";

const AuthControl = () => {
  const { user, handleLogout } = useAuth(); 

  const handleLogoutClick = () => {
    handleLogout();
  };

  return (
    <div>
      {user ? (
        <>
          <div>
            Bienvenido, {user}
            <Button variant="danger" onClick={handleLogoutClick}>
              Cerrar sesión
            </Button>
          </div>
        </>
      ) : (
        <p className="oculto">No estás logado</p>
      )}
    </div>
  );
};

export default AuthControl;
